import { ICustomer } from '@/schemas/Customer';

import { execGet } from '../utils/RequestUtils';

export async function getCustomerInformation(
  customerNumber: string,
  accessToken: string,
): Promise<ICustomer> {
  const response = await execGet<ICustomer>(
    `customer/${customerNumber}`,
    accessToken,
  );
  return response;
}
